<script>
    import AppMixin from './../../../mixins/AppMixin'
    import {Listeners} from "../../../constants/listeners";
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";
    import {store} from "../store";
    import InputNumber from "primevue/inputnumber";

    export default {
        mixins: [AppMixin],
        data() {
            return {
                name: 'TreeFilter',
                loading: false,
                error: null,
                model: {},
                config: {
                    [this.$t('lang.cluster.common_key_count')]: [
                        {condition: '<=', field: 'keysCountLess'}, {condition: '>=', field: 'keysCountMore'},
                    ],
                    [this.$t('lang.cluster.summ_ws')]: [
                        {condition: '<=', field: 'wsSumLess'}, {condition: '>=', field: 'wsSumMore'},
                    ],
                    [this.$t('lang.cluster.summ_wsk')]: [
                        {condition: '<=', field: 'wskSumLess'}, {condition: '>=', field: 'wskSumMore'},
                    ],
                    [this.$t('lang.cluster.summ_superwsk')]: [
                        {condition: '<=', field: 'superwskSumLess'}, {condition: '>=', field: 'superwskSumMore'},
                    ],
                    [this.$t('lang.cluster.ws_main_key')]: [
                        {condition: '<=', field: 'wsMaxLess'}, {condition: '>=', field: 'wsMaxMore'},
                    ],
                    [this.$t('lang.cluster.wsk_main_key')]: [
                        {condition: '<=', field: 'wskMaxLess'}, {condition: '>=', field: 'wskMaxMore'},
                    ],
                    [this.$t('lang.cluster.superwsk_main_key')]: [
                        {condition: '<=', field: 'superwskMaxLess'}, {condition: '>=', field: 'superwskMaxMore'},
                    ],
                },
                store: store,
            }
        },
        methods: {
            clear() {
                let data = {}, self = this;
                for (let prop in this.config) {
                    this.config[prop].forEach((c) => {
                        data[c.field] = null;
                        self.model[c.field] = null;
                    });
                }

                this.store.mutations.setTreeFilter(data);
                this.$emitter.emit(Listeners.CLUSTER_REFRESH_FILTER);
            },
            find() {
                let data = {};

                for (var prop in this.config) {
                    this.config[prop].forEach((c) => {
                        data[c.field] = this.model[c.field] ? this.model[c.field] : null;
                    });
                }

                this.store.mutations.setTreeFilter(data);
                this.$emitter.emit(Listeners.CLUSTER_REFRESH_FILTER);
                this.onClose();
            },
            onClose() {
                this.$emitter.emit(this.getDialogListenerCloseId);
            },
            onOpen(){
                this.model = {};

                for(let p in this.getFreeFilter){
                    this.model[p] = this.getFreeFilter[p];
                }

                this.$emitter.emit(this.getDialogListenerOpenId);
            },
        },
        computed: {
            getFreeFilter() {
                return this.store.getters.treeFilter();
            },
            isTreeFilter(){
                let self = this;
                return Object.keys(this.getFreeFilter).some(function(key, index) {
                    return self.getFreeFilter[key] !== null;
                });
            },
            resultStr(){
                let result = [], interResult = [];


                for (let prop in this.config) {
                    this.config[prop].forEach((c) => {
                        if(this.model.hasOwnProperty(c.field) && this.model[c.field] !== "" && this.model[c.field] !== null){
                            interResult.push(prop + " " + c.condition + " " + this.model[c.field]);
                        }
                    });

                    if(interResult.length > 0){
                        result.push("(" + interResult.join(" " + this.$t('lang.main.filter.and') + " ") + ")");
                        interResult = [];
                    }

                }

                if(result.length === 0){
                    return null;
                }

                return "(" + result.join(this.model.conditionOr ? (" " + this.$t('lang.main.filter.or') + " ") : (" " + this.$t('lang.main.filter.and') + " ")) + ")";
            },
            getDialogListenerOpenId() {
                return Listeners.CLUSTER_POPUP_TREE_FILTER_OPEN;
            },
            getDialogListenerCloseId() {
                return Listeners.CLUSTER_POPUP_TREE_FILTER_CLOSE;
            },
        },
        components: {
            AdaptersDialog,
            InputNumber,
        }
    }
</script>
<template>
    <div class="inline">
        <a href="#" class="graybutton" @click.prevent="onOpen" :title="$t('lang.cluster.add_filter')" id="tour-step-2"><i class="fa fa-filter" aria-hidden="true"></i></a>
        <a href="#" class="orangebutton" @click.prevent="clear" :title="$t('lang.cluster.clear_filter')" v-if="isTreeFilter"><i class="fa fa-times" aria-hidden="true"></i></a>

        <AdaptersDialog
            :listener-id="getDialogListenerOpenId"
            :listener-close-id="getDialogListenerCloseId"
            :header="$t('lang.cluster.add_filter')"
            :loading="loading"
            :callback-agree="find"
            :button-agree-label="$t('lang.main.btn.find')"
            :callback-additional="clear"
            :button-additional-label="$t('lang.main.btn.clear')"
        >
            <template #content>
                <div class="grid">
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="keysCountMore">{{ $t('lang.cluster.keys_more') }}</label>
                            <InputNumber v-model.number="model.keysCountMore" inputId="keysCountMore" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="keysCountLess">{{ $t('lang.cluster.keys_less') }}</label>
                            <InputNumber v-model.number="model.keysCountLess" inputId="keysCountLess" :min="0" />
                        </div>
                    </div>
                </div>
                <p>{{ $t('lang.cluster.dl_gr_ws_main') }}</p>
                <div class="grid">
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="wsMaxMore">
                                {{ this.isGoogleGny ? $t('lang.cluster.frequency_more') : $t('lang.cluster.ws_more') }}
                            </label>
                            <InputNumber v-model.number="model.wsMaxMore" inputId="wsMaxMore" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="wsMaxLess">
                                {{ this.isGoogleGny ? $t('lang.cluster.frequency_less') : $t('lang.cluster.ws_less') }}
                            </label>
                            <InputNumber v-model.number="model.wsMaxLess" inputId="wsMaxLess" :min="0" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="wskMaxMore">{{ $t('lang.cluster.wsk_more') }}</label>
                            <InputNumber v-model.number="model.wskMaxMore" inputId="wskMaxMore" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="wskMaxLess">{{ $t('lang.cluster.wsk_less') }}</label>
                            <InputNumber v-model.number="model.wskMaxLess" inputId="wskMaxLess" :min="0" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="superwskMaxMore">{{ $t('lang.cluster.superwsk_more') }}</label>
                            <InputNumber v-model.number="model.superwskMaxMore" inputId="superwskMaxMore" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="superwskMaxLess">{{ $t('lang.cluster.superwsk_less') }}</label>
                            <InputNumber v-model.number="model.superwskMaxLess" inputId="superwskMaxLess" :min="0" />
                        </div>
                    </div>
                </div>
                <p>{{ $t('lang.cluster.dl_gr_summ_ws') }}</p>
                <div class="grid">
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="wsSumMore">
                                {{ this.isGoogleGny ? $t('lang.cluster.frequency_more') : $t('lang.cluster.ws_more') }}
                            </label>
                            <InputNumber v-model.number="model.wsSumMore" inputId="wsSumMore" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="wsSumLess">
                                {{ this.isGoogleGny ? $t('lang.cluster.frequency_less') : $t('lang.cluster.ws_less') }}
                            </label>
                            <InputNumber v-model.number="model.wsSumLess" inputId="wsSumLess" :min="0" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="wskSumMore">{{ $t('lang.cluster.wsk_more') }}</label>
                            <InputNumber v-model.number="model.wskSumMore" inputId="wskSumMore" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="wskSumLess">{{ $t('lang.cluster.wsk_less') }}</label>
                            <InputNumber v-model.number="model.wskSumLess" inputId="wskSumLess" :min="0" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="superwskSumMore">{{ $t('lang.cluster.superwsk_more') }}</label>
                            <InputNumber v-model.number="model.superwskSumMore" inputId="superwskSumMore" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="superwskSumLess">{{ $t('lang.cluster.superwsk_less') }}</label>
                            <InputNumber v-model.number="model.superwskSumLess" inputId="superwskSumLess" :min="0" />
                        </div>
                    </div>
                </div>
                <template v-if="resultStr">
                    <div class="grid">
                        <div class="col">
                            <code>{{ resultStr }}</code>
                        </div>
                    </div>
                </template>
            </template>
        </AdaptersDialog>
    </div>
</template>
